import React, { useState, useEffect } from 'react';
import { handleSignInFromBiometric } from '../../actions/auth-action';
import { connect, useDispatch } from 'react-redux';
import { getLoginOptions } from '../../actions/biometric-action';
import { host } from '../../config';
import { toast } from 'react-toastify';
import {
  get,
  parseRequestOptionsFromJSON,
} from "@github/webauthn-json/browser-ponyfill";


const  BiometricLoginModal = (props)=> {
  const [email, setEmail] = useState('');
  const [history, setHistory] = useState([]);
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const { getLoginOptions,handleSignInFromBiometric,isOpen, onClose } = props;

  useEffect(() => {
    if (!isOpen) return;
    const stored = localStorage.getItem('biometricEmails');
    if (stored) {
      try {
        setHistory(JSON.parse(stored));
        setEmail(JSON.parse(stored)[0]?JSON.parse(stored)[0]:"")
      } catch {
        setHistory([]);
      }
    }
  }, [isOpen]);
  const login = async (email) => {
    if (!email) return alert("Please enter your email.");
     setIsLoggingIn(true);
    try {
      // 1. Get login options
      const options = await getLoginOptions(email)
      if (options.code === 400) {
        throw new Error(options.error);
      } 
      let asseResp;
      try {
        // Pass the options to the authenticator and wait for a response
        const optionsJson = parseRequestOptionsFromJSON({publicKey:options});
        asseResp  = await get(optionsJson)
        //asseResp = await startAuthentication({optionsJSON:options });
      } catch (error) {
        onClose();
        setIsLoggingIn(false);
        throw error;
      }
      const verificationResp = await fetch(host+'/webauthn/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(asseResp),
      });
      if (!verificationResp.ok) {
        onClose();
        console.error('Server responded with an error:', verificationResp.status);
        const errorText = await verificationResp.text();
        console.error('Error details:', errorText);
        setIsLoggingIn(false);
        throw new Error('Failed to verify login');
      } else {
        // Convert the response body to JSON.
        const data = await verificationResp.json();
        onClose();
        if(data.code === 200 && data.access_token) {
          handleSignInFromBiometric({data:data});
        }
        return data;
      }
     
      
    } catch (error) {
      onClose();
      console.error("WebAuthn login failed:", error);
      toast.error(`Error : ${error.message}`);
    } finally {
      setIsLoggingIn(false);
      onClose();
    }
  };

  const addToHistory = (value) => {
    const clean = value.trim();
    if (!clean) return;
    const updated = [clean, ...history.filter(e => e !== clean)].slice(0, 5);
    localStorage.setItem('biometricEmails', JSON.stringify(updated));
    setHistory(updated);
  };

  const handleLogin = () => {
    if (!email.trim()) return;
    addToHistory(email);
    login(email.trim());
    //onClose();
  };
  const handleEmailDirectClick = (email) => {
    if (!email.trim()) return;
    setEmail(email);
    addToHistory(email);
    login(email.trim());
    onClose();
  };

  return (
    <>  {/* Backdrop */}
      {isOpen && <div className="modal-backdrop fade show"></div>}
      <div
        className={`modal fade ${isOpen ? 'show d-block' : ''}`}
        tabIndex="-1"
        role="dialog"
        aria-modal={isOpen}
        aria-labelledby="biometricLoginLabel"
      >
        <div className="modal-dialog modal-dialog-centered modal-md" role="document">
          <div className="modal-content rounded-lg shadow-lg">
          <div className="modal-header border-0 justify-content-center position-relative">
              <h5 className="modal-title text-center w-100" id="biometricLoginLabel">
                Biometric Login
              </h5>
              <button
                type="button"
                className="close position-absolute"
                style={{ right: '1rem', top: '1rem' }}
                onClick={onClose}
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body px-4">
              <div className="mb-3">
                
                <input
                  type="text"
                  className="form-input input-with-icon password-bg auth-input"
                  placeholder="Enter your email"
                  aria-label="Email"
                  aria-describedby="email-addon"
                  value={email}
                  autocomplete="chrome-off"
                  onChange={e => setEmail(e.target.value)}
                />
              </div>
              {history.length > 0 && (
                <div className="mb-3">
                  <small className="text-muted">Recent emails</small>
                  <ul className="users-list list-group list-group-flush rounded overflow-hidden shadow-sm">
                    {history.map(addr => (
                      <li
                        key={addr}
                        className="list-group-item list-group-item-action"
                        onClick={() => handleEmailDirectClick(addr)}
                      >
                        {addr}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
            <div className="modal-footer border-0 d-flex justify-content-end px-4 pb-4">
              <button type="button" className="grey-button small mr-2" onClick={onClose}>
                Cancel
              </button>
              <button type="button" className="blue-button small" onClick={handleLogin} disabled={isLoggingIn}>
                {isLoggingIn ? "logging in.." : "Login"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default connect(null, { getLoginOptions, handleSignInFromBiometric })(BiometricLoginModal);
